// Centralised route constants for the treasury refund-requests module.
// Backend route renames are a one-file change.

const REFUND_REQUESTS = '/api/admin/treasury/refund-requests'

export const REFUND_REQUESTS_ENDPOINT_PATHS = {
  LIST: REFUND_REQUESTS,
  STATUS_COUNTS: `${REFUND_REQUESTS}/status-counts`,
  DETAIL: (id: string) => `${REFUND_REQUESTS}/${id}`,
  APPROVE: (id: string) => `${REFUND_REQUESTS}/${id}/approve`,
  REJECT: (id: string) => `${REFUND_REQUESTS}/${id}/reject`,
} as const
